import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
export default (function (_ref) {
  var appearance = _ref.appearance,
      elemAfterInput = _ref.elemAfterInput,
      elemBeforeInput = _ref.elemBeforeInput,
      forwardedRef = _ref.forwardedRef,
      isCompact = _ref.isCompact,
      isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isHovered = _ref.isHovered,
      isInvalid = _ref.isInvalid,
      isMonospaced = _ref.isMonospaced,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      onMouseDown = _ref.onMouseDown,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["appearance", "elemAfterInput", "elemBeforeInput", "forwardedRef", "isCompact", "isDisabled", "isFocused", "isHovered", "isInvalid", "isMonospaced", "isReadOnly", "isRequired", "onMouseDown", "onMouseEnter", "onMouseLeave", "theme"]);

  return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    ___EmotionJSX("div", {
      css: theme.container,
      onMouseDown: onMouseDown,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, elemBeforeInput, ___EmotionJSX("input", _extends({
      ref: forwardedRef,
      disabled: isDisabled,
      readOnly: isReadOnly,
      required: isRequired,
      css: theme.input
    }, rest)), elemAfterInput)
  );
});